import './Properties.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';

import { Navigation, Autoplay } from 'swiper/modules';

import { FaBed, FaBath, FaCar, FaRulerCombined, FaHeart } from 'react-icons/fa';

export default function Properties() {

  const properties = [
    {
      title: "Marion",
      address: "Bengaluru",
      price: "Rs.800/mo",
      img: "https://picsum.photos/400/250?1",
      beds: 2,
      baths: 1,
      garage: 1,
      area: 250
    },
    {
      title: "Luxury Family Home",
      address: "Chennai",
      price: "Rs.1800/mo",
      img: "https://picsum.photos/400/250?2",
      beds: 3,
      baths: 1,
      garage: 1,
      area: 250
    },
    {
      title: "Arlo Apartment",
      address: "Kochin",
      price: "Rs.1500/mo",
      img: "https://picsum.photos/400/250?3",
      beds: 4,
      baths: 1,
      garage: 1,
      area: 250
    },
    {
      title: "New Apartment Nice View",
      address: "Mumbai",
      price: "Rs.1500/mo",
      img: "https://picsum.photos/400/250?4",
      beds: 3,
      baths: 2,
      garage: 1,
      area: 225
    }
  ];

  return (
    <section className="properties">
      <div className="container">

        <h2>Recent Properties for Rent</h2>
        <p className="sub">Explore your journey by choosing the best options in the marketplace</p>

        <Swiper
          modules={[Navigation, Autoplay]}
          navigation
          autoplay={{ delay: 3000 }}
          loop={true}
          spaceBetween={25}
          slidesPerView={4}   
          breakpoints={{
             1390: { slidesPerView: 4 },
            1024: { slidesPerView: 3 },
            768: { slidesPerView: 2 },
            480: { slidesPerView: 1 }
          }}
        >
          {properties.map((item, i) => (
            <SwiperSlide key={i}>

              <div className="card">

                {/* IMAGE */}
                <div className="img-box">
                  <img src={item.img} alt="" />

                  <span className="badge featured">FEATURED</span>
                  <span className="badge rent">FOR RENT</span>
                </div>

                {/* CONTENT */}
                <div className="content">
                  <h3>{item.title}</h3>
                  <p className="address">{item.address}</p>

                  <div className="info">
                    <span><FaBed /> {item.beds} Beds</span>
                    <span><FaBath /> {item.baths} Baths</span>
                    <span><FaCar /> {item.garage} Garages</span>
                    <span><FaRulerCombined /> {item.area} sqft</span>
                  </div>
                </div>

                {/* FOOTER */}
                <div className="footer-properties">
                  <h4>{item.price}</h4>
                  <div className="actions">
                    <FaHeart />
                  </div>
                </div>

              </div>

            </SwiperSlide>
          ))}
        </Swiper>

      </div>
    </section>
  );
}